import { Autocomplete } from '@base-ui/react/autocomplete';

import type { SearchItem, SearchResultItem, SearchResultSource } from '../../../search.types';
import { SearchResultAssistButton } from './search-result-assist-button';
import { SearchResultLink } from './search-result-link';

const GROUP_LABELS: Record<SearchItem['kind'], string> = {
    recent: 'Recent searches',
    query: 'Popular searches',
    product: 'Product results',
};

type SearchResultGroupProps = {
    onResult: (result: SearchResultItem) => void;
    query: string;
    source: SearchResultSource;
};

export function SearchResultGroup({ onResult, query, source }: Readonly<SearchResultGroupProps>) {
    const label = source.kind === 'query' && query !== '' ? '' : GROUP_LABELS[source.kind];

    return (
        <Autocomplete.Group className="header-search__group" items={source.items} role="rowgroup">
            {label && (
                <Autocomplete.Row className="header-search__group-label-row">
                    <Autocomplete.GroupLabel className="header-search__group-label" role="gridcell">
                        {label}
                    </Autocomplete.GroupLabel>
                </Autocomplete.Row>
            )}
            {source.rows.map(row => (
                <Autocomplete.Row key={row.primary.id} className="header-search__row">
                    <SearchResultLink onResult={onResult} query={query} result={row.primary} />
                    {row.assisted && <SearchResultAssistButton onResult={onResult} result={row.assisted} />}
                </Autocomplete.Row>
            ))}
        </Autocomplete.Group>
    );
}
